<template>
  <v-container class="container-custom">
    <router-view :normalUploadedDocs="normalUploadedDocs" :normalDocumentationRequired="normalDocumentationRequired" :documentationUploaded="documentationUploaded "></router-view>
    <v-progress-circular v-if="loading" class="loader primary--text" indeterminate ></v-progress-circular>
    <v-container v-else-if="showPhotograph">
      <Breadcrumbs
        :title="$t('modules.portalalumno.admission.documentation.title')"
        size="sm"
      ></Breadcrumbs>
      <div>
        <v-row>
          <v-col sm="11">
            <DocumentLegend :documentationUploaded="documentationUploaded"/>
            <v-card  outlined class="docu-container my-15">
              <v-row class="general_description pl-3">
                <div>
                  <v-icon class="icon-alert pr-2 pb-8">mdi-alert-circle</v-icon>
                  <h4 >{{ $t('modules.portalalumno.admission.alert.noteDoc') }}</h4>
                </div>
                <h4 class="ml-7 ">
                    {{ $t('modules.portalalumno.admission.documentation.requiredFields1') }}
                    <v-icon class="pb-1" color="red" size="8px">mdi-asterisk</v-icon>
                    {{ $t('modules.portalalumno.admission.documentation.requiredFields2') }}
                </h4>
              </v-row>
              <div class="cards-container mt-10">
                <v-card
                  outlined
                  v-for="(documentation,index) in normalDocumentationRequired"
                  :class="['cards',
                    {
                      'documentation-status--rejected': normalDocumentationRejected[index],
                      'documentation-status--sendOk' : uploadStatus[index] === true,
                      'documentation-status--sendBad' : uploadStatus[index] === false,
                    }
                  ]"
                  :data-status-message="statusMessages[index]"
                  :elevation="normalDocumentationRejected[index] ? 3 : 0"
                  :key="`req-doc-${index}`"
                >
                  <div>
                    <h3>
                      {{ documentation.name}}
                      <v-icon v-if="!documentation.optional" class="pb-2" color="red" size="10px">mdi-asterisk</v-icon>
                    </h3>
                    <h4 class="mt-1 mb-3">{{ documentation.description }}</h4>
                    <v-container v-if="normalUploadedDocs[index]?.length > 0">
                      <v-divider/>
                      <v-list class="items-uploaded">
                        <v-list-item
                          v-for="(item, i) in [...normalUploadedDocs[index]]"
                          :key="i"
                        >
                          <v-list-item-content>
                            <div v-if="documentation.id == 2" class="mb-3">
                              <h5 class="title_certificate mr-6">
                                {{ $t('modules.portalalumno.admission.documentation.nCertificate') }}
                              </h5>
                              <h5 >{{ item.certificateNumber || 'Sin especificar' }}</h5>
                            </div>
                            <div class="mb-3">
                                <h4 class="status_title mr-3">{{$t('modules.portalalumno.admission.documentation.statusDoc') }}</h4>
                                <v-icon class="mr-2" :class="item.statusClass">{{ item.statusIcon }}</v-icon>
                                  <h4 class="status_meaning">{{ item.meaning }}</h4>
                            </div>
                            <div v-if="documentation.id !== 46" style="width: 100%;">
                                <v-list-item-title class="file_meaning">{{ item.filename }}</v-list-item-title>
                                <v-icon class="file_icon" color="primary"
                                    @click="downloadFile(item)">mdi-cloud-download-outline</v-icon>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-container>
                    <v-text-field
                      v-if="showFileUploader(documentation.id) && documentation.id == 2"
                      class="text-certificate mt-4"
                      :disabled="disabledSave || !normalDocumentation[1].length"
                      v-model="nCertificate"
                      label="N° de certificado"
                      outlined
                      >
                    </v-text-field>
                    <v-card
                      outlined
                      class="cards"
                      v-if="documentation.id == 46"
                    >
                      <Button
                        @clicked="goToPhotographs"
                        class="btn"
                        :text="btnPhotograph"
                        outlined
                        size="small"
                      />
                    </v-card>
                    <FileUploader
                    v-else-if="showFileUploader(documentation.id)"
                    formatsAccepted=".pdf,.jpg,.jpeg,.png"
                    :documentation="documentation"
                    :files.sync="normalDocumentation[index]"
                    :process="false"
                    :isMultiple="true"
                    :disabled="disabledSave"
                    :finished="finished"
                    />
                  </div>
                </v-card>
              </div>
            </v-card>
            <v-card outlined class="docu-container" v-if="needScholarshipDocumentation">
              <h1 class="body-1 font-weight-bold primary--text mb-10">{{$t('modules.portalalumno.admission.documentation.scholarshipDocumentation')}}</h1>
              <div class="cards-container mt-10">
                <v-card
                  outlined
                  v-for="(documentation,index) in scholarshipDocumentationRequired"
                  :class="['cards',scholarshipDocumentationRejected[index]? 'documentation-rejected' : '']"
                  :elevation="scholarshipDocumentationRejected[index] ? 2 : 0"
                  :key="`req-doc-${index}`">
                  <div class="d-block">
                    <h1 class="body-1 font-weight-bold ma-0">{{documentation.name}}</h1>
                    <h2 class="body-2 mt-1 mb-3">{{documentation.description}}</h2>
                    <template v-if="scholarshipUploadedDocs[index]?.length>0">
                    <v-divider/>
                    <v-list class="files-list">
                      <h2 class="caption my-1">{{$t('modules.portalalumno.admission.documentation.revisedDocumentation')}}</h2>
                      <v-list-item
                        v-for="(item, i) in scholarshipUploadedDocs"
                        :key="i"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{item.filename}}</v-list-item-title>
                        </v-list-item-content>
                        <div class="d-flex align-center caption font-weight-bold">
                          <v-icon class="mr-2" :class="item.statusClass">{{item.statusIcon}}</v-icon>
                          {{ item.statusText }}
                        </div>
                      </v-list-item>
                    </v-list>
                    </template>
                    <v-divider/>
                    <FileUploader
                      :isEnabled="documentation.status"
                      formatsAccepted=".pdf,.jpg,.jpeg,.png"
                      :files.sync="scholarshipDocumentation[index]"
                      :process="false"
                      />
                  </div>
                </v-card>
              </div>
            </v-card>
            <v-card outlined class="docu-container" v-if="needBenefitDocumentation">
              <h1 class="body-1 font-weight-bold primary--text mb-10">{{$t('modules.portalalumno.admission.documentation.benefitDocumentation')}}</h1>
              <div class="cards-container mt-10">
                <v-card
                  outlined
                  v-for="(documentation,index) in benefitDocumentationRequired"
                  :class="['cards',benefitDocumentationRejected[index]? 'documentation-rejected' : '']"
                  :elevation="benefitDocumentationRejected[index] ? 2 : 0"
                  :key="`req-doc-${index}`"
                >
                  <div class="d-block">
                    <h1 class="body-1 font-weight-bold ma-0">{{documentation.name}}</h1>
                    <h2 class="body-2 mt-1 mb-3">{{documentation.description}}</h2>
                    <template v-if="benefitUploadedDocs[index]?.length>0">
                    <v-divider/>
                    <v-list class="files-list">
                      <h2 class="caption my-1">{{$t('modules.portalalumno.admission.documentation.revisedDocumentation')}}</h2>
                      <v-list-item
                        v-for="(item, i) in benefitUploadedDocs"
                        :key="i"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{item.filename}}</v-list-item-title>
                        </v-list-item-content>
                        <div class="d-flex align-center caption font-weight-bold">
                          <v-icon class="mr-2" :class="item.statusClass">{{item.statusIcon}}</v-icon>
                          {{ item.statusText }}
                        </div>
                      </v-list-item>
                    </v-list>
                    </template>
                    <v-divider/>
                    <FileUploader
                      :isEnabled="documentation.status"
                      formatsAccepted=".pdf,.jpg,.jpeg,.png"
                      :files.sync="benefitDocumentation[index]"
                      :process="false"
                      />
                  </div>
                </v-card>
              </div>
            </v-card>
            <Button
              class="btn-container pt-10"
              primary
              :text="$t('modules.portalalumno.admission.documentation.sendDocumentation')"
              :disabled="disabledSave"
              :loading="sendButton.loading"
              :success="sendButton.success"
              :error="sendButton.error"
              :successText="$t('actions.sent')"
              :errorText="'Error'"
              @end="resetButtonValues"
              @clicked="sendDocumentation"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-container>
</template>


<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import { mapState, mapMutations } from 'vuex'
import FileUploader from '@/components/FileUploader/FileUploader.vue'
import { $studentProcessing, $processings } from '../services'
import Button from '@/components/Button/Button'
import { mapGetters } from 'vuex'
import DocumentLegend from '../Components/DocumentLegend.vue'

export default {
  name: 'DocumentationUpload',
  components: {
    Breadcrumbs,
    FileUploader,
    Button,
    DocumentLegend,
  },
  data() {
    return {
      loading: false,
      sendButton: {
        loading: false,
        success: false,
        error: false,
      },
      benefitDocumentationRequired: [],
      benefitDocumentation:[],
      certificateNumber: null,
      documentationUploaded:[],
      procedureStatus: null,
      normalDocumentationRequired: [],
      normalDocumentation:[],
      nCertificate: null,
      observation: null,
      showPhotograph: false,
      uploadStatus: [],
      scholarshipDocumentation:[],
      scholarshipDocumentationRequired:[],
      statusMessages: [],
      toUpload:[],
      finished: null,
    }
  },
  computed: {
    ...mapMutations('commons', [
      'clearPendingPhotographs'
    ]),
     ...mapState('commons', [
      'pendingPhotographs'
    ]),
    ...mapGetters({
            studentRegister: 'commons/getStudentActualRegister',
            studentId: 'commons/getStudentId',
            studentData: 'commons/getStudentData',
            studentUserId: 'commons/getStudentUserID'
        }),
    btnPhotograph(){
      const hasPhotoDoc = this.normalUploadedDocs?.some((docA) =>
        docA?.some(ieia => ieia.documentationId === 46)
      );
      return hasPhotoDoc
        ? this.$t('modules.portalalumno.admission.photograph.postPhotograph')
        : this.$t('modules.portalalumno.admission.photograph.prePhotograph')
    },
    showFileUploader() {
      return (docId) => !this.documentationUploaded?.some(doc => doc.documentation.id === docId && doc.docStatus.value !== 95)
    },
    needScholarshipDocumentation(){
      return this.scholarshipDocumentationRequired?.length > 0
    },
    needBenefitDocumentation(){
      return this.benefitDocumentationRequired?.length > 0
    },
    status(){
      if(this.$route.params.dataDocumentation?.description == 'Carga de documentacion obligatoria'){
        return{
          isNew: true,
          class: 'status-revision',
          icon:'mdi-plus',
          text: 'Nueva',
        }
      }else{
        switch(this.procedureStatus?.value){
          case 91:
            return {
              isNew: false,
              class: 'status-info',
              icon: 'mdi-alert-outline',
              text: this.procedureStatus?.meaning,
            }
          case 93:
              return{
                isNew: true,
                class: 'status-success',
                icon:' mdi-check-circle-outline',
                text: this.procedureStatus?.meaning,
              }
          case 113:
            return {
              isNew: false,
              class: 'status-warning',
              icon: 'mdi-alert-outline',
              text: this.procedureStatus?.meaning,
            }
          default:
            return 0
        }
      }
    },
    normalUploadedDocs() {
      const normalDocumentations = []
      this.normalDocumentationRequired.forEach((docType) => {
        const normalDocsFiltered = this.documentationUploaded?.filter((doc) => {
          return docType.id === doc.documentation.id
        })?.map((docFiltered) => {
          const mappedDoc = this.mapDocumentationState(docFiltered)
          mappedDoc.certificateNumber = docFiltered?.certificateNumber || null
          mappedDoc.documentationId = docType?.id || null
          mappedDoc.subTypeId = docFiltered.documentation.documentationSubtype?.id || null
          return mappedDoc
        }) || []

      if (docType.id === 46 && this.pendingPhotographs && Object.keys(this.pendingPhotographs).length > 0) {
          Object.entries(this.pendingPhotographs).forEach(([subtypeId, photos]) => {
            photos.forEach(photo => {
              normalDocsFiltered.push({
                isApproved: false,
                id: null,
                filename: photo.file[0]?.name,
                status: 'C',
                statusIcon: 'mdi-check-circle-outline',
                statusClass: 'icon-approved',
                statusText: 'Subido',
                meaning: 'Cargado temporalmente',
                upload: true,
                statusDoc: null,
                documentationId: 46,
                subTypeId: Number(subtypeId),
              })
            })
          })
        }
        normalDocumentations.push(normalDocsFiltered)
      });

      return normalDocumentations;
    },
    normalDocumentationRejected() {
      const rejecteds = []
      this.normalUploadedDocs?.forEach((docType, docTypeIndex) => {
        const lastDoc = docType[docType?.length - 1]
        rejecteds[docTypeIndex] = lastDoc ? (!lastDoc.isApproved && lastDoc.statusDoc === 95) : false
      })
      return rejecteds
    },
    scholarshipUploadedDocs(){
      const scholarshipDocumentations = []
      this.scholarshipDocumentationRequired?.forEach(docType => {
        const scholarshipDocsFiltered = this.documentationUploaded?.filter(doc=>{
          return docType.id === doc.documentation.id
        }).map(docFiltered => {
          return this.mapDocumentationState(docFiltered)
        })
        scholarshipDocumentations.push(scholarshipDocsFiltered);
      });
      return scholarshipDocumentations
    },
    scholarshipDocumentationRejected(){
      const rejecteds = []
      this.scholarshipUploadedDocs.forEach((docType,docTypeIndex)=>{
        rejecteds[docTypeIndex] = !!docType?.find(doc => !doc.isApproved) &&
        (this.scholarshipDocumentation[docTypeIndex] && this.scholarshipDocumentation[docTypeIndex]?.length < 1);
      })
      return rejecteds
    },
    benefitUploadedDocs(){
      const benefitDocumentations = [];
      this.benefitDocumentationRequired.forEach(docType => {
        const benefitDocsFiltered = this.documentationUploaded?.filter(doc=>{
          return docType.id === doc.documentation.id;
        }).map(docFiltered => {
          return this.mapDocumentationState(docFiltered)
        })
        benefitDocumentations.push(benefitDocsFiltered)
      });
      return benefitDocumentations
    },
    benefitDocumentationRejected(){
      const rejecteds = []
      this.benefitUploadedDocs.forEach((docType,docTypeIndex)=>{
        rejecteds[docTypeIndex] = !!docType.find(doc=>!doc.isApproved) && this.benefitDocumentation[docTypeIndex]?.length < 1;
      })
      return rejecteds
    },
    disabledSave(){
      if(this.finished){
        return true
      }
      const hasPendingPhotographs = this.pendingPhotographs && Object.values(this.pendingPhotographs).some(arr => arr && arr.length > 0);

      if (hasPendingPhotographs) return false;

      else if(this.status.isNew && this.status.text != 'Pendiente' && !this.status.text == 'Aprobado'){
        return (!!this.normalDocumentation?.find((doc, i) => doc?.length < 1 && !this.normalDocumentationRequired[i].optional)
                || !!this.scholarshipDocumentation?.find(doc => doc?.length < 1)
                || !!this.benefitDocumentation?.find(doc => doc?.length < 1)
                )
      }else if( this.status.text == 'Pendiente' || this.status.text == 'Observado' || this.status.text == 'Aprobado' ){
        return   (!this.normalDocumentation?.find((doc) => doc?.length > 0))
      }else{
        return(this.benefitDocumentationRejected?.find(status => status)
              || this.scholarshipDocumentationRejected?.find(status => status)
              || this.normalDocumentationRejected?.find(status => status)
              )
      }
    }
  },
  beforeRouteEnter(to,_,next){
    const params = Object.keys(to?.params ?? {})?.length
    if(!params) next(vm => vm.$router.go(-1))
    next()
  },
  mounted() {
    this.showPhotograph = !this.$route.meta.hideComponent;
    this.initialize()
  },
  watch: {
    '$route': function(to) {
      this.showPhotograph = !to.meta.show;
    }
  },
  methods: {
    resetButtonValues() {
      this.sendButton.loading = false;
      this.sendButton.success = false;
      this.sendButton.error = false;
    },
    async initialize(){
      this.loading = true;
      await this.getNormalDocumentationRequired();
      await this.getScholarshipDocumentationRequired();
      await this.getBenefitDocumentationsRequired();
      const resp = await this.getProcedureStatus();
      if(!resp) this.isUpload()
      this.loading = false;
    },
    async getNormalDocumentationRequired(){
      const response = (await $processings?.find(`required-documentations`)).data
      response.documentations.forEach(doc=>{
        this.normalDocumentationRequired.push(doc);
        this.normalDocumentation.push([])
      })
    },
    getScholarshipDocumentationRequired(){
      this.studentData.scholarship?.scholarshipDocumentation?.forEach(doc => {
        this.scholarshipDocumentationRequired.push(doc.documentation);
        this.scholarshipDocumentation.push([]);
      })
    },
    getBenefitDocumentationsRequired(){
      this.studentData.benefit?.benefitDocumentation?.forEach(doc => {
        this.benefitDocumentationRequired.push(doc.documentation);
        this.benefitDocumentation.push([]);
      })
    },
    getDniName(){
      if(this.$isIPP){
        return 'Cédula de identidad'
      } else {
        return 'DNI'
      }
    },
    getAnalitycName(){
      if(this.$isIPP){
        return 'Certificado de educación media'
      } else {
        return 'ANALITICO'
      }
    },
    getAnalitycInputPosition(){
      if(this.$isIPP){
        return 2
      } else {
        return 1
      }
    },
    async getProcedureStatus() {
      if (this.studentData && ( this.$route.params.dataDocumentation.key != 'MANDATORY_DOCUMENTATION' && this.$route.params.dataDocumentation ))  {
        const {data} = await $studentProcessing?.find(this.$route.params.dataDocumentation.id);
        this.procedureStatus = data.processingStatus;
        this.observation = data?.commentary
        this.documentationUploaded = data?.documentations
        this.certificateNumber =  data?.documentations?.find(n => n.certificateNumber)?.certificateNumber || null
      }else{
        return true
      }
    },
    getDocumentationsPropsToSave(docs_array, docs_types_array){
      docs_array.forEach((docType,docTypeIndex)=>{
        if (docType?.length > 0) {
          this.toUpload.push({
            idDocumentationType: docs_types_array[docTypeIndex].id,
            file: docType,
            index: docTypeIndex
          });
        }
      });
    },
    makeSingleDocumentationArray(){
      this.toUpload = [];
      this.getDocumentationsPropsToSave(this.normalDocumentation,
      this.normalDocumentationRequired,
      this.normalUploadedDocs);
      this.getDocumentationsPropsToSave(this.scholarshipDocumentation,
      this.scholarshipDocumentationRequired,
      this.scholarshipUploadedDocs);
      this.getDocumentationsPropsToSave(this.benefitDocumentation,
      this.benefitDocumentationRequired,
      this.benefitUploadedDocs);
    },
    mapDocumentationState(documentation){
      const isApproved = documentation?.docStatus.value === 94;
      return {
        isApproved,
        id: documentation.id,
        filename: documentation.fileName,
        status: isApproved ? 'A' : 'R',
        statusIcon: isApproved ? 'mdi-check-circle-outline'
        : (documentation?.docStatus.value == 96 || documentation?.docStatus.value == 257) ? 'mdi-pencil-circle'
        : (documentation?.docStatus.value == 258) ? 'mdi-progress-clock'
        : 'mdi-close-circle-outline',
        statusClass: isApproved ? 'icon-approved'
        : (documentation?.docStatus.value == 96 || documentation?.docStatus.value == 257) ? 'icon-pending'
        : (documentation?.docStatus.value == 258) ? 'icon-review'
        : 'icon-rejected',
        statusText: isApproved ? 'Aprobado' : 'Rechazado',
        meaning:documentation?.docStatus.meaning,
        upload: documentation.upload,
        statusDoc: documentation?.docStatus.value
      }
    },
    async sendDocumentation() {
      this.makeSingleDocumentationArray();
      this.sendButton.loading = true
      this.resetButtonValues()

      try {
        if (this.pendingPhotographs && Object.keys(this.pendingPhotographs).length > 0) {
          for (const [subtypeId, photos] of Object.entries(this.pendingPhotographs)) {
            photos.forEach(photo => {
              this.toUpload.push({
                ...photo,
                idDocumentationSubtype: Number(subtypeId),
                idDocumentationType: 46
              })
            })
          }
        }

        for (let i = 0; i < this.toUpload?.length; i++) {
          const doc = this.toUpload[i]
          const formData = new FormData()
          const isPhotograph = doc.idDocumentationType === 46
          const photoIndex = this.normalDocumentationRequired.findIndex(d => d.id === 46)

          try {
            const model = {
              studentRecord: this.studentData.academicRegister,
              user: this.studentUserId || null,
              student: {
                id: this.studentData.student.id,
                user: {
                  name: this.studentData.student.user.name,
                }
              },
              idDocumentation: doc.idDocumentationType,
              idDocumentationSubtype: doc.idDocumentationSubtype || null,
              certificateNumber: this.nCertificate || null,
            }

            formData.append('model', JSON.stringify(model))
            doc.file.forEach(file => {
              formData.append('documentation', file)
            })

            await $studentProcessing.formData(formData, 'required-documentation')

            if (isPhotograph && photoIndex !== -1) {
              this.uploadStatus[photoIndex] = true
              this.statusMessages[photoIndex] = this.$t('modules.portalalumno.admission.documentation.uploadSuccess')
            } else if (typeof doc.index === 'number') {
              this.uploadStatus[doc.index] = true
              this.statusMessages[doc.index] = this.$t('modules.portalalumno.admission.documentation.uploadSuccess')
            }

            this.sendButton.success = true

          } catch (error) {
            if (isPhotograph && photoIndex !== -1) {
              this.uploadStatus[photoIndex] = false
              this.statusMessages[photoIndex] = this.$t('modules.portalalumno.admission.documentation.uploadError')
            } else if (typeof doc.index === 'number') {
              this.uploadStatus[doc.index] = false
              this.statusMessages[doc.index] = this.$t('modules.portalalumno.admission.documentation.uploadError')
            }

            this.sendButton.error = true
          }
        }

        this.$trackEvent('Tramites', 'Clk_BtnEnvDocObl_Tram', 'DocuObligatoria')

      } finally {
        this.sendButton.loading = false
        setTimeout(() => {
          this.finished = true
        }, 2500)
      }

      this.clearPendingPhotographs()
    },
    isUpload(){
      function filterEnabled(doc) {
        const result =  doc.map(el => {
          if ( el.statusDoc === 95 || el.upload === true || el.statusDoc === 257 || el.statusDoc === 258 ) {
            return  true
          }else{
            return false
          }
        })
        if (doc?.length == 0) return [true]
          return result
      }
      this.normalUploadedDocs.map((el,index) => {
          this.normalDocumentationRequired[index].status = filterEnabled(el,index).includes(true)
      })
    },
    async downloadFile(file){
      const fileDownload = (await $studentProcessing?.find(`/documentation/${file.id}`)).data
      if (fileDownload) {
        const link = document.createElement('a');
        link.download = file.filename;
        link.href = fileDownload;
        link.click();
      }
    },
    goToPhotographs() {
      this.$router.push({
        name: 'Fotografías para titulación',
      });
    },
  }
}
</script>
<style lang="sass" scoped>
@mixin display ($display: null, $align: null, $just: null)
  display: $display
  align-items: $align
  justify-content: if($just == 'end', 'flex-end', $just)

@mixin font ($size, $weight: normal, $color: black)
  font-size: $size
  font-weight: $weight
  color: $color
@mixin icon ($size: 20px, $padding: 1%, $color: null)
  font-size: $size
  padding: $padding
  color: $color
.loader
  top: 50%
  left: 50%
.docu-container
  border: none
  .general_description
    div
      @include display (flex)
  h1, h2, h3, h4, h5
    @include font (null)
  .icon-alert
    color: #21D9E0
    font-size: 21px
  .cards-container
    @include display (grid)
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr))
    align-items: start
    gap: 8%
    padding-bottom: 4%
    .cards
      border-radius: 15px
      flex-direction: column
      border: solid 2px #E2E4E5
      padding: 8%
      .items-uploaded
        div
          @include display (flex)
        .title_certificate
          @include font (13px, null, gray)
        .status_title
          @include font (13px, null, null)
          @include display (flex, center, null)
        .icon-approved
          @include icon (21px, 2px, green)
        .icon-review
          @include icon (13px, 2px, white)
          width: 19px
          height: 19px
          border-radius: 50px
          background-color: #3D6CD9
        .icon-pending
          @include icon (21px, 2px, #FB8C00)
        .icon-rejected
          @include icon (21px, 2px, red)
        .status_meaning
          @include font (13px, null, gray)
          @include display (flex, center, null)
        .file_meaning
          @include display (block)
          @include font (19px, bold, #888D94)
          max-width: 80%
        .file_icon
          @include display (flex)
          margin-left: auto !important

    .text-certificate
      width: 50%
  .btn
    transform: scale(0.8)
    text-align: center
    ::v-deep .v-btn__content
      font-size: large

.btn-container
  @include display (flex, null ,end)

.documentation-status
  position: relative
  border-width: 1px
  border-style: solid
  background-color: red

  &--rejected
    border: 1px solid #ff8686 !important

  &--sendOk, &--sendBad
    &:before
      content: attr(data-status-message)
      position: absolute
      width: calc(100%)
      top: 1px
      left: 0px
      font-size: 14px
      padding: 5px 20px
      border: none
      border-radius: 10px 10px 0 0

  &--sendOk
    border-color: #4CAF50 !important
    color: #4CAF50
    &:before
      background-color: #E8F5E9

  &--sendBad
    border-color: #FF5252 !important
    color: #FF5252
    &:before
      background-color: #FFEBEE

</style>
